import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const STORAGE_KEY = 'il_girasole_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          role="dialog"
          aria-modal="true"
          aria-label="Cookie-Einwilligung"
          className="fixed bottom-0 left-0 right-0 z-50 bg-olive-900 text-cream shadow-2xl px-5 py-5 sm:px-8"
        >
          <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Text */}
            <div className="flex-1 font-body text-sm text-cream/90 leading-relaxed">
              <span className="font-semibold text-cream">🍪 Diese Website verwendet Cookies.</span>{' '}
              Wir setzen technisch notwendige Cookies ein, um den Betrieb der Website zu gewährleisten.
              Weitere Informationen finden Sie in unserer{' '}
              <Link
                to="/datenschutz"
                className="underline underline-offset-2 hover:text-gold transition-colors"
                onClick={accept}
              >
                Datenschutzerklärung
              </Link>
              .
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={decline}
                className="font-body text-xs uppercase tracking-widest px-4 py-2 border border-cream/30 text-cream/70 hover:border-cream hover:text-cream transition-colors"
              >
                Ablehnen
              </button>
              <button
                onClick={accept}
                className="font-body text-xs uppercase tracking-widest px-5 py-2 bg-terracotta text-white hover:bg-terracotta-dark transition-colors"
              >
                Akzeptieren
              </button>
              <button
                onClick={decline}
                aria-label="Schließen"
                className="text-cream/50 hover:text-cream transition-colors ml-1"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
